export default "__VITE_ASSET__CEhEHtQb__"